var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Heading, Icon } from '@digitools/honest-react';
import { Link as ReactLink, NavLink } from 'react-router-dom';
import useAuthentication from '../../../hooks/useAuthentication';
import { TEALIUM_EVENT } from '../../../constants/tealiumConstants';
import useTealium from '../../../hooks/useTealium';
import LfgLogo from '../../../assets/lfg-new-logo.svg';
var StyledHeader = styled.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  margin-top: 1rem;\n  padding-bottom: 1rem;\n  margin-bottom: 1rem;\n  @media (max-width: 767px) {\n    & {\n      align-items: ", ";\n      border-bottom: none;\n      flex-direction: ", ";\n      margin-bottom: 5rem;\n    }\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  margin-top: 1rem;\n  padding-bottom: 1rem;\n  margin-bottom: 1rem;\n  @media (max-width: 767px) {\n    & {\n      align-items: ", ";\n      border-bottom: none;\n      flex-direction: ", ";\n      margin-bottom: 5rem;\n    }\n  }\n"])), function (_a) {
  var isLoggedIn = _a.isLoggedIn;
  return isLoggedIn ? 'flex-start' : 'center';
}, function (_a) {
  var isLoggedIn = _a.isLoggedIn;
  return isLoggedIn ? 'column' : 'row';
});
var Logo = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 143px;\n  height: 49px;\n  @media (max-width: 991px) {\n    & {\n      width: 140px;\n    }\n  }\n"], ["\n  width: 143px;\n  height: 49px;\n  @media (max-width: 991px) {\n    & {\n      width: 140px;\n    }\n  }\n"])));
var ProtectedDiv = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative; \n  display: inline-block; \n  img {\n    pointer-events: none;     /* right-click can't target the img */\n    user-select: none;\n    -webkit-user-drag: none;\n  }\n  \n  .overlay { position: absolute; inset: 0; }\n"], ["\n  position: relative; \n  display: inline-block; \n  img {\n    pointer-events: none;     /* right-click can't target the img */\n    user-select: none;\n    -webkit-user-drag: none;\n  }\n  \n  .overlay { position: absolute; inset: 0; }\n"])));
var HeaderWelcomeText = styled(Heading)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-left: auto;\n  font-weight: bold;\n"], ["\n  margin-left: auto;\n  font-weight: bold;\n"])));
var HeaderNavContainer = styled.nav(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  margin: 0;\n  padding: 0;\n  margin-left: auto;\n  @media (max-width: 767px) {\n    & {\n      flex-direction: column;\n      margin-left: 0;\n      margin-top: 1rem;\n      width: 100%;\n    }\n  }\n"], ["\n  display: flex;\n  margin: 0;\n  padding: 0;\n  margin-left: auto;\n  @media (max-width: 767px) {\n    & {\n      flex-direction: column;\n      margin-left: 0;\n      margin-top: 1rem;\n      width: 100%;\n    }\n  }\n"])));
var HeaderNavItem = styled(NavLink)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  list-style-type: none;\n  font-weight: '400';\n  font-size: 17px;\n  margin: 0;\n  padding: 1rem;\n  @media (max-width: 991px) {\n    & {\n      font-size: 15px;\n      padding: 1rem 0.5rem;\n    }\n  }\n  @media (max-width: 767px) {\n    & {\n      border-right: none;\n      border-bottom: 1px solid ", ";\n    }\n  }\n  @media (min-width: 767px) {\n    & + & {\n      border-left: 1px solid ", ";\n    }\n  }\n"], ["\n  color: ", ";\n  list-style-type: none;\n  font-weight: '400';\n  font-size: 17px;\n  margin: 0;\n  padding: 1rem;\n  @media (max-width: 991px) {\n    & {\n      font-size: 15px;\n      padding: 1rem 0.5rem;\n    }\n  }\n  @media (max-width: 767px) {\n    & {\n      border-right: none;\n      border-bottom: 1px solid ", ";\n    }\n  }\n  @media (min-width: 767px) {\n    & + & {\n      border-left: 1px solid ", ";\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.grayDark;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.grayLighter;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.grayLighter;
});
var LogoContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  width: auto;\n  @media (max-width: 767px) {\n    & {\n      width: ", ";\n    }\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  width: auto;\n  @media (max-width: 767px) {\n    & {\n      width: ", ";\n    }\n  }\n"])), function (_a) {
  var isLoggedIn = _a.isLoggedIn;
  return isLoggedIn ? '100%' : 'auto';
});
var MobileNavIconButton = styled.button(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  align-items: center;\n  background: none;\n  border: none;\n  display: flex;\n  flex-direction: column;\n  margin-left: auto;\n  &:hover {\n    cursor: pointer;\n  }\n  @media (min-width: 768px) {\n    & {\n      display: none;\n    }\n  }\n"], ["\n  align-items: center;\n  background: none;\n  border: none;\n  display: flex;\n  flex-direction: column;\n  margin-left: auto;\n  &:hover {\n    cursor: pointer;\n  }\n  @media (min-width: 768px) {\n    & {\n      display: none;\n    }\n  }\n"])));
var MobileNavIcon = styled(Icon)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin-bottom: 0.5rem;\n  & + span {\n    display: block;\n    font-size: 12px;\n    font-weight: bold;\n    text-transform: uppercase;\n  }\n"], ["\n  margin-bottom: 0.5rem;\n  & + span {\n    display: block;\n    font-size: 12px;\n    font-weight: bold;\n    text-transform: uppercase;\n  }\n"])));
var Header = function () {
  var _a = useState(false),
    isMobileNavShown = _a[0],
    setIsMobileNavShown = _a[1];
  var user = useAuthentication().user;
  var trackEvent = useTealium().trackEvent;
  var theme = useContext(ThemeContext);
  var navItems = [{
    label: 'Verify benefits',
    href: '/benefit-details',
    isVisible: true
  }, {
    label: 'Claims status',
    href: '/claims',
    isVisible: true
  }, {
    label: 'Network affiliation',
    href: '/network-search',
    isVisible: true
  }, {
    label: 'Help center',
    href: '/help-center',
    isVisible: true
  }];
  useEffect(function () {
    var handleResize = function () {
      if (window.innerWidth >= 767) {
        setIsMobileNavShown(true);
      } else if (window.innerWidth < 767) {
        setIsMobileNavShown(false);
      }
    };
    window.addEventListener('resize', handleResize);
    if (window.innerWidth >= 767) {
      setIsMobileNavShown(true);
    }
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var LoggedInLogo = function () {
    return _jsx(ReactLink, __assign({
      to: '/home',
      onClick: function () {
        trackEvent({
          event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
          event_name: 'Lincoln Dental Provider Member Search Link',
          event_type: TEALIUM_EVENT.EVENT_TYPE.MM_LINK
        });
      },
      "aria-label": 'Go to member search page',
      "data-testid": 'logged-in-logo-link'
    }, {
      children: _jsxs(ProtectedDiv, {
        children: [_jsx(Logo, {
          alt: 'Lincoln Financial',
          src: LfgLogo
        }), _jsx("div", {
          className: "overlay",
          "aria-hidden": "true"
        })]
      })
    }));
  };
  var LoggedOutLogo = function () {
    return _jsx(ReactLink, __assign({
      to: '/login',
      onClick: function () {
        trackEvent({
          event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
          event_name: 'Lincoln Dental Provider Portal Home Link',
          event_type: TEALIUM_EVENT.EVENT_TYPE.MM_LINK
        });
      },
      "aria-label": 'Go to login page',
      "data-testid": 'logged-out-logo-link'
    }, {
      children: _jsxs(ProtectedDiv, {
        children: [_jsx(Logo, {
          alt: 'Lincoln Financial',
          src: LfgLogo
        }), _jsx("div", {
          className: "overlay",
          "aria-hidden": "true"
        })]
      })
    }));
  };
  var trackNavItemClick = function (name) {
    trackEvent({
      event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
      event_name: name,
      event_type: TEALIUM_EVENT.EVENT_TYPE.H_LINK
    });
  };
  return _jsxs(StyledHeader, __assign({
    isLoggedIn: !!user,
    "data-public": true
  }, {
    children: [_jsxs(LogoContainer, __assign({
      isLoggedIn: !!user
    }, {
      children: [!!user ? _jsx(LoggedInLogo, {}) : _jsx(LoggedOutLogo, {}), !!user && _jsxs(MobileNavIconButton, __assign({
        onClick: function () {
          return setIsMobileNavShown(function (prev) {
            return !prev;
          });
        }
      }, {
        children: [_jsx(MobileNavIcon, {
          name: 'bars-solid',
          size: 'medium'
        }), _jsx("span", {
          children: "Menu"
        })]
      }))]
    })), user ? _jsx(HeaderNavContainer, __assign({
      "data-testid": 'header-nav',
      role: 'navigation',
      "aria-label": 'header navigation'
    }, {
      children: navItems.map(function (navItem, key) {
        return isMobileNavShown && navItem.isVisible && _jsx(HeaderNavItem, __assign({
          "data-testid": navItem.label + '-navItem',
          id: key.toString(),
          to: navItem.href,
          "aria-label": 'Go to ' + navItem.label,
          activeStyle: {
            color: theme.palette.primary,
            fontWeight: 500,
            pointerEvents: 'none'
          },
          onClick: function () {
            trackNavItemClick(navItem.label);
          }
        }, {
          children: navItem.label
        }), key);
      })
    })) : _jsxs(HeaderWelcomeText, __assign({
      elemType: 'h1',
      elemStyle: 'h4',
      style: {
        fontWeight: 'bold'
      },
      color: 'primary',
      "data-testid": 'header-welcome'
    }, {
      children: [_jsxs("i", {
        children: ["Lincoln DentalConnect", _jsx("sup", __assign({
          style: {
            fontSize: '8px'
          }
        }, {
          children: "\u00AE"
        }))]
      }), ' ', "provider portal"]
    }))]
  }));
};
export default Header;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;